<template>
  <div class="nuttrema-images-list" :class="[ theme ? `theme-${theme}` : '' ]">
    <div class="image"
       v-for="image in images"
      :style="{ 'background-image': getImagePath(image) }"
      @click="handleShowGallery(image.id)">
      <div v-if="image.main" class="main-image" :title="$t('label.main')"></div>
      <div class="image-text" v-if="haveText(image.title) || haveText(image.description)">
        <div class="ttl" v-if="haveText(image.title)">
          <span :title="image.title">{{ image.title }}</span>
        </div>
        <div class="dsc" v-if="haveText(image.description)">
          <span :title="image.description">{{ image.description }}</span>
        </div>
      </div>
    </div>
    <nuttrema-images-gallery
      :showGallery.sync="showGallery"
      :theme="theme"
      :images="images">
    </nuttrema-images-gallery>
  </div>
</template>

<script>
import { get, isNil } from 'lodash';

import NuttremaImagesGallery from './nuttrema-images-gallery';

export default {
  name: 'nuttrema-images-list',
  props: {
    images: {
      required: true,
      default: null,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaImagesGallery,
  },
  data() {
    return {
      showGallery: null,
    };
  },
  methods: {
    getImagePath(image) {
      const path = get(image, 'path', '');
      const filename = get(image, 'thumbnails.large.filename', '');
      return `url(${process.env.IMAGES_ROOT}${path}${filename})`;
    },
    haveText(value) {
      return !isNil(value) && value !== '';
    },
    handleShowGallery(id) {
      this.showGallery = id;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  @import '~styles/mixins/gradients';

  .nuttrema-images-list {
    flex-grow: 1;
    display: flex;
    flex-wrap: wrap;
    align-self: stretch;
    align-items: flex-start;
    padding: 1.25em;
    padding-left: 0;
    justify-content: flex-start;
    align-content: flex-start;
    background-color: rgba(255,255,255,0.75);

    &:after {
      z-index: 0;
      width: 100%;
      content: '';
      height: 100%;
      opacity: 0.1;
      position: absolute;
      background: transparent url('~assets/images/dc-logo-bg.svg') no-repeat 125% 125%;
      background-size: 62em;
    }

    .image {
      z-index: 1;
      width: 9em;
      height: 9em;
      display: flex;
      flex-shrink: 0;
      overflow: hidden;
      position: relative;
      margin: 0 0 1.25em 1.25em;
      border-radius: 0.5em;
      background-color: #99f;
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: center center;
      box-shadow: 0 0 5px rgba(0,0,0, 0.25);

      .main-image {
        width: 4em;
        top: 0.5em;
        right: -1em;
        height: 0.5em;
        position: absolute;
        transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        background-color: #20a0ff;
        -webkit-transform: rotate(45deg);
        box-shadow: 0 2px 5px rgba(0,0,0,0.25);
        @include gradient-horizontal(#20a0ff, #3273dc);
      }

      .image-text {
        opacity: 0;
        width: 100%;
        color: #fff;
        display: flex;
        visibility: hidden;
        align-self: flex-end;
        padding: 0.25em 0.35em;
        flex-direction: column;
        border-bottom-left-radius: 0.5em;
        border-bottom-right-radius: 0.5em;
        transition: visibility 0s, opacity 0.15s;
        background-color: rgba($state-info-text, 0.75);
        .ttl {
          flex-shrink: 0;
          font-weight: 500;
          font-size: 0.95rem;
          position: relative;
          align-self: stretch;
        }
        .dsc {
          flex-shrink: 0;
          font-size: 0.85rem;
          position: relative;
          align-self: stretch;
          margin-top: -0.25em;
        }
        .ttl, .dsc {
          height: 1.25em;
          span {
            overflow: hidden;
            position: absolute;
            white-space: nowrap;
            display: inline-block;
            text-overflow: ellipsis;
            top: 0; bottom: 0; left: 0; right: 0;
          }
        }
      }

      &:hover {
        box-shadow: 0 0 10px rgba($state-info-text, 0.5);
        cursor: pointer;
        .image-text {
          visibility: visible;
          opacity: 1;
        }
      }
    }

    &.theme-embedded {
      padding: 0;
      margin-top: 1em;
      &:after {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/images/nuttrema-images-list.vue